// Additional
import MarkHospital from "../../static/images/mark-hospital-small.svg";
import MarkSchool from "../../static/images/mark-school-small.svg";
import MarkShopping from "../../static/images/mark-shopping-small.svg";

import MarkBus1 from "../../static/images/mark-bus-1.svg";
import MarkBus2 from "../../static/images/mark-bus-2.svg";
import MarkBus3 from "../../static/images/mark-bus-3.svg";

// Projects
import OneReemIsland from "../../static/images/projects/One Reem Island.svg";
import ReemFive from "../../static/images/projects/Reem Five.svg";
import ReemEight from "../../static/images/projects/Reem Eight.svg";
import ReemNine from "../../static/images/projects/Reem Nine.svg";
import ReemEleven from "../../static/images/projects/Reem Eleven.svg";
import SAASBusinessTower from "../../static/images/projects/SAAS Business Tower.svg";

// Landmarks
import AbuDhabiInternationalAirport from "../../static/images/landmarks/abu_dhabi_international_airport.svg";
import KhalifaPort from "../../static/images/landmarks/khalifa_port.svg";
import MinaZayedPort from "../../static/images/landmarks/mina_zayed_port.svg";
import SheikhZayedGrandMosque from "../../static/images/landmarks/sheikh_zayed_grand_mosque.svg";
import LouvreAbuDhabi from "../../static/images/landmarks/louvre_abu_dhabi.svg";
import FerrariWorld from "../../static/images/landmarks/ferrari_world.svg";
import YasWaterworld from "../../static/images/landmarks/yas_waterworld.svg";
import EmiratesPalace from "../../static/images/landmarks/emirates_palace.svg";
import QasrAlHosn from "../../static/images/landmarks/qasr_al_hosn.svg";
import AlAinOasis from "../../static/images/landmarks/al_ain_oasis.svg";
import HeritageVillage from "../../static/images/landmarks/heritage_village.svg";
import Headquarters from "../../static/images/landmarks/headquarters.svg";
import AbuDhabiGlobalMarket from "../../static/images/landmarks/abu_dhabi_global_market.svg";
import MasdarCity from "../../static/images/landmarks/masdar_city.svg";
import AbuDhabiPortsFreeZone from "../../static/images/landmarks/abu_dhabi_ports_free_zone.svg";
import AlAinIndustrialCity from "../../static/images/landmarks/al_ain_industrial_city.svg";
import MussafahIndustrialArea from "../../static/images/landmarks/mussafah_industrial_area.svg";
import AlMaryahIslandBusinessDistrict from "../../static/images/landmarks/al_maryah_island_business_district.svg";
import IndustrialCityOfAbuDhabi from "../../static/images/landmarks/industrial_city_of_abu_dhabi.svg";
import AbuDhabiAirportFreeZone from "../../static/images/landmarks/abu_dhabi_airport_free_zone.svg";
import TwoFour54MediaZone from "../../static/images/landmarks/two_four_54_media_zone.svg";
import KhalifaIndustrialZone from "../../static/images/landmarks/khalifa_industrial_zone.svg";
import AbrahamicFamilyHouse from "../../static/images/landmarks/abrahamic_family_house.svg";
import AlBahrTowers from "../../static/images/landmarks/al_bahr_towers.svg";
import AldarHeadquarters from "../../static/images/landmarks/aldar_headquarters.svg";
import AlJahiliFort from "../../static/images/landmarks/al_jahili_fort.svg";
import SheikhZayedBridge from "../../static/images/landmarks/sheikh_zayed_bridge.svg";
import BurjMohammedBinRashid from "../../static/images/landmarks/burj_mohammed_bin_rashid.svg";
import CapitalGateBuilding from "../../static/images/landmarks/capital_gate_building.svg";
import QasrAlWatan from "../../static/images/landmarks/qasr_al_watan.svg";
import EmiratesPalaceMandarinOriental from "../../static/images/landmarks/emirates_palace_mandarin_oriental.svg";
import WAbuDhabi from "../../static/images/landmarks/w_abu_dhabi.svg";
import EtihadTowers from "../../static/images/landmarks/etihad_towers.svg";
import WahatAlKarama from "../../static/images/landmarks/wahat_al_karama.svg";

import ReemIslandMangroveForest from "../../static/images/landmarks/reem_island_mangrove_forest.svg";
import ReemCentralParkAndBeach from "../../static/images/landmarks/reem_central_park_and_beach.svg";
import AlFayPark from "../../static/images/landmarks/al_fay_park.svg";
import WarnerBrothersWorld from "../../static/images/landmarks/warner_brothers_world.svg";
import YasBeach from "../../static/images/landmarks/yas_beach.svg";
import YasLinks from "../../static/images/landmarks/yas_links.svg";
import YasMarinaCircuit from "../../static/images/landmarks/yas_marina_circuit.svg";
import YasGatewayParkNorth from "../../static/images/landmarks/yas_gateway_park_north.svg";
import Seaworld from "../../static/images/landmarks/seaworld.svg";
import Clymb from "../../static/images/landmarks/clymb.svg";
import YasBayWaterfront from "../../static/images/landmarks/yas_bay_waterfront.svg";

import Bird2Background from "../../static/images/birds/bird2/Bird_View_3.jpg";
import { ReactComponent as Bird2OneReemIsland } from "../../static/images/birds/bird2/projects/one_reem_island_polygon.svg";
import { ReactComponent as Bird2ReemFive } from "../../static/images/birds/bird2/projects/reem_five_polygon.svg";
import { ReactComponent as Bird2ReemEight } from "../../static/images/birds/bird2/projects/reem_eight_polygon.svg";
import { ReactComponent as Bird2ReemNine } from "../../static/images/birds/bird2/projects/reem_nine_polygon.svg";
import { ReactComponent as Bird2ReemEleven } from "../../static/images/birds/bird2/projects/reem_eleven_polygon.svg";
import { ReactComponent as Bird2SaasBusinessTower } from "../../static/images/birds/bird2/projects/saas_business_tower_polygon.svg";
import Bird1PIN from "../../static/images/birds/bird1/projects/PIN.svg";

//Projects images
import OneReemIslandImg from "../../static/images/OneReemIslandImg.jpg";
import ReemFiveImg from "../../static/images/ReemFiveImg.jpg";
import ReemEightImg from "../../static/images/ReemEightImg.jpg";
import ReemNineImg from "../../static/images/ReemNineImg.jpg";
import ReemElevenImg from "../../static/images/ReemElevenImg.jpg";
import SAASBusinessTowerImg from "../../static/images/SAASBusinessTowerImg.png";

import {
    // Infrastructure
    schools,
    hospitals,
    retails,

    // Polygons

    // Polylines
    bus_road_1,
    bus_road_2,
    bus_road_3,
    bus_road_1_stops,
    bus_road_2_stops,
    bus_road_3_stops,
    bus_road_1_2,
} from "./Coords";

export const infrastrMarkers = [
    {
        id: "health",
        allCoords: hospitals,
        icon: MarkHospital,
    },
    {
        id: "education",
        allCoords: schools,
        icon: MarkSchool,
    },
    {
        id: "retail_or_shopping",
        allCoords: retails,
        icon: MarkShopping,
    },
];

export const markers = [
    {
        id: "one_reem_island",
        checkIsInGroup: true,
        groupName: ["residential_developments"],
        zoomLevel: null,
        coords: { lat: 24.4973702019508, lng: 54.4080807821649 },
        polygonCoords: [],
        icon: OneReemIsland,
        activeIcon: null,
        anchor: {
            x: 98,
            y: 45,
        },
        clickable: {
            marker: true,
            polygon: true,
        },
        content: {
            type: "bird_link",
            bird_id: "bird2",
            // type: "card",
            // title: "One Reem Island",
            // previews: [OneReemIslandImg],
            // desc: "One Reem Island provides an exceptional living experience, located at the centre of Reem Island, Abu Dhabi with a beachfront setting. Nestled into the capital’s skyline and with views of Abu Dhabi’s renowned mangroves, the striking façade of One Reem Island provides.",
            // video: null,
            // buttons: [
            //     {
            //         type: "double",
            //         data: [
            //             {
            //                 text: "BIRD VIEW",
            //                 action_type: "open_bird",
            //                 bird_id: "bird2",
            //                 data: null,
            //             },
            //             {
            //                 text: "DISCOVER",
            //                 action_type: "open_link",
            //                 data: null,
            //                 link: "https://saasproperties.com/en/properties/city/abu-dhabi/property/one-reem-island",
            //             },
            //         ],
            //     },
            // ],
        },
    },
    {
        id: "reem_five",
        checkIsInGroup: true,
        groupName: ["residential_developments"],
        zoomLevel: null,
        coords: { lat: 24.5074819496522, lng: 54.4055259257771 },
        polygonCoords: [],
        icon: ReemFive,
        activeIcon: null,
        anchor: {
            x: 19,
            y: 47,
        },
        clickable: {
            marker: true,
            polygon: true,
        },
        content: {
            type: "bird_link",
            bird_id: "bird2",
            // type: "card",
            // title: "Reem Five",
            // previews: [ReemFiveImg],
            // desc: "The sleek exterior of Reem Five solidifies its presence in an incredible location on Abu Dhabi's Reem Island, where the glittering urban city skyline is complemented by the surrounding natural beauty of the mangroves and Arabian waves. Beachfront living provides a sense of calm and gentility which carries through to the interiors of the property, where nature's presence in the fixtures and finishes is abundant. With just 59 exclusive residences from studio through to three-bedroom, the homes within Five Reem are spread generously across eight storeys.",
            // video: null,
            // buttons: [
            //     {
            //         type: "double",
            //         data: [
            //             {
            //                 text: "BIRD VIEW",
            //                 action_type: "open_bird",
            //                 bird_id: "bird2",
            //                 data: null,
            //             },
            //             {
            //                 text: "DISCOVER",
            //                 action_type: "open_link",
            //                 data: null,
            //                 link: "https://saasproperties.com/en/properties/city/abu-dhabi/property/reem-five",
            //             },
            //         ],
            //     },
            // ],
        },
    },
    {
        id: "reem_eight",
        checkIsInGroup: true,
        groupName: ["residential_developments"], //Change groupName name Vasyl Narbut
        zoomLevel: null,
        coords: { lat: 24.4982475471281, lng: 54.4092212783665 },
        polygonCoords: [],
        icon: ReemEight,
        activeIcon: null,
        anchor: {
            x: 20,
            y: 45,
        },
        clickable: {
            marker: true,
            polygon: true,
        },
        content: {
            type: "bird_link",
            bird_id: "bird2",
            // type: "card",
            // title: "Reem Eight",
            // previews: [ReemEightImg],
            // desc: "Reem Eight's waterfront position and modern facade offers a striking combination for those looking to find a haven of serenity and peace at the end of the working day without extensive travel. Whilst offering excellent connectivity to an abundance of amenities, Reem Eight's 54 homes have been designed to provide sanctuaries of tranquillity to their residents.",
            // video: null,
            // buttons: [
            //     {
            //         type: "double",
            //         data: [
            //             {
            //                 text: "BIRD VIEW",
            //                 action_type: "open_bird",
            //                 bird_id: "bird2",
            //                 data: null,
            //             },
            //             {
            //                 text: "DISCOVER",
            //                 action_type: "open_link",
            //                 data: null,
            //                 link: "https://saasproperties.com/en/properties/city/abu-dhabi/property/reem-eight",
            //             },
            //         ],
            //     },
            // ],
        },
    },
    {
        id: "reem_nine",
        checkIsInGroup: true,
        groupName: ["residential_developments"], //Change groupName name Vasyl Narbut
        zoomLevel: null,
        coords: { lat: 24.4963468529819, lng: 54.4106280924276 },
        polygonCoords: [],
        icon: ReemNine,
        activeIcon: null,
        anchor: {
            x: 51,
            y: 45,
        },
        clickable: {
            marker: true,
            polygon: true,
        },
        content: {
            type: "bird_link",
            bird_id: "bird2",
            // type: "card",
            // title: "Reem Nine",
            // previews: [ReemNineImg],
            // desc: "From a walking distance to Reem Island's central park and canal, Reem Nine offers an incredible array of unexpected amenities for all residents, from state-of-the-art gym equipment to an on-site cinema, there has been no detail overlooked in creating a community which provides a haven from the buzz of the city. With one to three-bedroom homes, each apartment has been designed to convey the sense of space and light, whilst the development offers views of the mangroves and waterfront for tranquillity and comfort.",
            // video: null,
            // buttons: [
            //     {
            //         type: "double",
            //         data: [
            //             {
            //                 text: "BIRD VIEW",
            //                 action_type: "open_bird",
            //                 bird_id: "bird2",
            //                 data: null,
            //             },
            //             {
            //                 text: "DISCOVER",
            //                 action_type: "open_link",
            //                 data: null,
            //                 link: "https://saasproperties.com/en/properties/city/abu-dhabi/property/reem-nine",
            //             },
            //         ],
            //     },
            // ],
        },
    },
    {
        id: "reem_eleven",
        checkIsInGroup: true,
        groupName: ["residential_developments"],
        zoomLevel: null,
        coords: { lat: 24.5035340633524, lng: 54.4111220071839 },
        polygonCoords: [],
        icon: ReemEleven,
        activeIcon: null,
        anchor: {
            x: 29,
            y: 45,
        },
        clickable: {
            marker: true,
            polygon: true,
        },
        content: {
            type: "bird_link",
            bird_id: "bird2",
            // type: "card",
            // title: "Reem Eleven",
            // previews: [ReemElevenImg],
            // desc: "Reem Eleven is a stunning luxury residential tower featuring furnished studios-1 bedroom apartments, and 2-3 bedroom apartments at the heart of Reem Island. This exceptional tower offers an unmatched living experience, with resort-style amenities and lavish living spaces. Located close to everything that matters, Reem Eleven is rapidly taking shape with 19 floors already complete and handover anticipated in Q4 2025.",
            // video: null,
            // buttons: [
            //     {
            //         type: "double",
            //         data: [
            //             {
            //                 text: "BIRD VIEW",
            //                 action_type: "open_bird",
            //                 bird_id: "bird2",
            //                 data: null,
            //             },
            //             {
            //                 text: "DISCOVER",
            //                 action_type: "open_link",
            //                 data: null,
            //                 link: "https://saasproperties.com/en/properties/city/abu-dhabi/property/reem-eleven",
            //             },
            //         ],
            //     },
            // ],
        },
    },
    {
        id: "saas_business_tower",
        checkIsInGroup: true,
        groupName: ["residential_developments"],
        zoomLevel: null,
        coords: { lat: 24.500835, lng: 54.409765 },
        polygonCoords: [],
        icon: SAASBusinessTower,
        activeIcon: null,
        anchor: {
            x: 145,
            y: 47,
        },
        clickable: {
            marker: true,
            polygon: true,
        },
        content: {
            type: "bird_link",
            bird_id: "bird2",
            // type: "card",
            // title: "SAAS Business Tower",
            // previews: [SAASBusinessTowerImg],
            // desc: "SAAS Business Tower stands as a beacon of modernity and sustainability in the prestigious Abu Dhabi Global Market (ADGM) on Reem Island, Abu Dhabi. With its bold, contemporary design and Pearl 3 Estidama Certification—equivalent to Gold/Platinum LEED status—this luxurious 29-story tower represents the pinnacle of sustainable commercial development.",
            // video: null,
            // buttons: [
            //     {
            //         type: "double",
            //         data: [
            //             {
            //                 text: "BIRD VIEW",
            //                 action_type: "open_bird",
            //                 bird_id: "bird2",
            //                 data: null,
            //             },
            //             {
            //                 text: "DISCOVER",
            //                 action_type: "open_link",
            //                 data: null,
            //                 link: "https://saasproperties.com/en/properties/city/abu-dhabi/property/reem-eleven",
            //             },
            //         ],
            //     },
            // ],
        },
    },
    // {
    //     id: "mont_rose",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.069341756091543, lng: 55.24579313 },
    //     polygonCoords: [],
    //     icon: MontRoseIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         type: "card",
    //         title: "Mont Rose",
    //         previews: [],
    //         desc: "Mont Rose is a three-tower living address that features 19-storey residential towers. The contemporary design with its modern facade, makes this residency an enticing home.",
    //         video: null,
    //         buttons: [
    //             {
    //                 type: "single",
    //                 data: [
    //                     {
    //                         text: "WEB SITE",
    //                         data: null,
    //                         link: "https://www.deyaar.ae/en/properties/montrose/",
    //                     },
    //                 ],
    //             },
    //         ],
    //     },
    // },
    // {
    //     id: "al_dana_tower",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.35673679, lng: 55.38797992 },
    //     polygonCoords: [],
    //     icon: AlDanaTowerIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Al Dana Tower',
    //         // previews: [],
    //         // desc: '',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/al-dana-towers/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird4",
    //     },
    // },
    // {
    //     id: "amalia",
    //     checkIsInGroup: true,
    //     groupName: ["future_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.01904442, lng: 55.14419822 },
    //     polygonCoords: [],
    //     icon: AmaliaIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         type: "card",
    //         title: "Amalia by Deyaar",
    //         previews: [],
    //         desc: "Perfectly located in an upscale vibrant community, the mid-rise residential tower has been devised with intricate use of light that adds more brightness and space to your home contentment. Amalia Residences offers meticulously designed one, two, and three-bedroom apartments.",
    //         video: null,
    //         buttons: [
    //             {
    //                 type: "single",
    //                 data: [
    //                     {
    //                         text: "WEB SITE",
    //                         data: null,
    //                         link: "https://www.deyaar.ae/en/properties/amalia/",
    //                     },
    //                 ],
    //             },
    //         ],
    //     },
    // },
    // {
    //     id: "talia_millenium",
    //     checkIsInGroup: true,
    //     groupName: ["asset_management", "future_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.02046071, lng: 55.15233505 },
    //     polygonCoords: [],
    //     icon: TaliaMilleniumIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         type: "card",
    //         title: "Talia Millenium by Deyaar",
    //         previews: [],
    //         desc: "Owners get the chance to enjoy exclusive features, such as access to a state-of-the-art swimming pool, Children’s Play Area, Indoor Gymnasium, Outdoor Training Area, Sauna and Steam Rooms, Prayer Hall, Concierge Desk, Gift Shop, and Food & Beverage outlets.",
    //         video: null,
    //         buttons: [
    //             {
    //                 type: "single",
    //                 data: [
    //                     {
    //                         text: "WEB SITE",
    //                         data: null,
    //                         link: "https://www.deyaar.ae/en/properties/talia/",
    //                     },
    //                 ],
    //             },
    //         ],
    //     },
    // },
    // {
    //     id: "deyaar_head_office",
    //     checkIsInGroup: true,
    //     groupName: ["commercial_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.11694525, lng: 55.19676335 },
    //     polygonCoords: [],
    //     icon: DeyaarHeadOfficeIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Deyaar Head Office',
    //         // previews: [],
    //         // desc: '',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/deyaar-head-office/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird1",
    //     },
    // },
    // {
    //     id: "the_burlington",
    //     checkIsInGroup: true,
    //     groupName: ["commercial_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.18501228, lng: 55.26452025 },
    //     polygonCoords: [],
    //     icon: TheBurlingtonIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'The Burlington',
    //         // previews: [],
    //         // desc: 'Located in the most prestigious area of Business Bay, The Burlington will showcase some of the most esteemed names in the business world.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/burlington/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird4",
    //     },
    // },
    // {
    //     id: "the_metropolis",
    //     checkIsInGroup: true,
    //     groupName: ["commercial_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.1849364, lng: 55.27690069 },
    //     polygonCoords: [],
    //     icon: TheMetropolisIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'The Metropolis',
    //         // previews: [],
    //         // desc: 'The Metropolis is on par with leading international names in the commercial world, offering position and power of a perfect location in the world’s most powerful business community – the Business Bay of Dubai.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/the-metropolis/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird4",
    //     },
    // },
    // {
    //     id: "the_citadel_tower",
    //     checkIsInGroup: true,
    //     groupName: ["commercial_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.18403985, lng: 55.26089546 },
    //     polygonCoords: [],
    //     icon: TheCitadelTowerIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'The Citadel Tower',
    //         // previews: [],
    //         // desc: 'Located in an enviable position in Business Bay, this corporate business tower boasts 41 floors of beautifully designed office spaces overlooking the bay.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/the-citadel/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird4",
    //     },
    // },
    // {
    //     id: "fifty_one_business_bay",
    //     checkIsInGroup: true,
    //     groupName: ["commercial_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.19016094, lng: 55.28427176 },
    //     polygonCoords: [],
    //     icon: FiftyOneBusinessBayIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Fifty One & Business Bay',
    //         // previews: [],
    //         // desc: 'A state-of-the-art commercial tower, 51 & Business Bay is a perfect harmony of elegance, functionality and convenience.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/fifty-one/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird4",
    //     },
    // },
    // {
    //     id: "oxford_tower",
    //     checkIsInGroup: true,
    //     groupName: ["commercial_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.17721836, lng: 55.2732984 },
    //     polygonCoords: [],
    //     icon: OxfordTowerIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Oxford Tower',
    //         // previews: [],
    //         // desc: 'Oxford Tower is the exclusive address that compliments your business and positions it in the heart of a vibrant business district. Flaunt the stature that your business exudes and join the leading corporate names of the world.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/oxford-tower/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird4",
    //     },
    // },
    // {
    //     id: "the_atria",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.18069035, lng: 55.26376082 },
    //     polygonCoords: [],
    //     icon: TheAtriaIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'The Atria',
    //         // previews: [],
    //         // desc: 'The apartments at The Atria are designed in the yoo Studio Culture Style. Eclectic yet refined, the Culture palette encapsulates a passion for appropriating the most beautiful and exquisitely produced objects and ideas from the past, and placing them alongside the most amazing designs of today.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/the-atria/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird4",
    //     },
    // },
    // {
    //     id: "coral_residence",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.10866114, lng: 55.37953722 },
    //     polygonCoords: [],
    //     icon: CoralResidenceIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Coral Residence',
    //         // previews: [],
    //         // desc: '',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: '/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird3",
    //     },
    // },
    // {
    //     id: "ruby_residence",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.11476999, lng: 55.39024227 },
    //     polygonCoords: [],
    //     icon: RubyResidenceIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Ruby Residence',
    //         // previews: [],
    //         // desc: '',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: '/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird3",
    //     },
    // },
    // {
    //     id: "oakwood_residence",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.04044145, lng: 55.19246704 },
    //     polygonCoords: [],
    //     icon: OakwoodResidenceIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Oakwood Residence',
    //         // previews: [],
    //         // desc: 'Completed in 2013 this residential building comprises 18 floors of well-thought, functional, and beautifully finished one and two-bedroom apartments.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/oakwood-residency/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird1",
    //     },
    // },
    // {
    //     id: "madison_residency",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.10025468, lng: 55.17533066 },
    //     polygonCoords: [],
    //     icon: MadisonResidencyIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Madison Residency',
    //         // previews: [],
    //         // desc: 'Take in a rock concert, catch the buzz of the Dubai International Film Festival, enjoy a round of Golf, or widen your horizons at the Knowledge Village. Indulge in everything from fine cuisine, shopping and trendy clubs, exciting nightlife, upscale shopping malls, designer boutiques, and ethnic gourmet restaurants.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/madison-residency/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird1",
    //     },
    // },
    // {
    //     id: "al_seef_tower",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.09063221, lng: 55.15009494 },
    //     polygonCoords: [],
    //     icon: AlSeefTowerIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Al Seef Tower',
    //         // previews: [],
    //         // desc: '',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/al-seef-tower/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird2",
    //     },
    // },
    // {
    //     id: "hamilton_residency",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.18606978, lng: 55.28606661 },
    //     polygonCoords: [],
    //     icon: HamiltonResidencyIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Hamilton Residency',
    //         // previews: [],
    //         // desc: 'With life getting hectic day after day, you probably find that work makes unreasonable demands on your time, leaving you feeling stretched and stressed. Having a home close to your office helps you strike the right balance.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/hamilton-residency/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird4",
    //     },
    // },
    // {
    //     id: "fairview_residency",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.18174885, lng: 55.27968833 },
    //     polygonCoords: [],
    //     icon: FairviewResidencyIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Fairview Residency',
    //         // previews: [],
    //         // desc: 'Completed in 2014, this 18-floor residential tower offers its residents well-designed and comfortable apartments overlooking the Business Bay lake.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/fairview-residency/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird4",
    //     },
    // },
    // {
    //     id: "mayfair_residency",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.1819574, lng: 55.27722001 },
    //     polygonCoords: [],
    //     icon: MayfairResidencyIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Mayfair Residency',
    //         // previews: [],
    //         // desc: 'Offering a choice of 1 and 2 bedroom apartments, Mayfair Residency is designed to impress with its stylish finishes and scenic views of the Business Bay lake.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/mayfair-residency/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird4",
    //     },
    // },
    // {
    //     id: "clayton_residency",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.18268817, lng: 55.2829059 },
    //     polygonCoords: [],
    //     icon: ClaytonResidencyIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Clayton Residency',
    //         // previews: [],
    //         // desc: 'An ultra-contemporary residential project from DEYAAR, Clayton Residency will exemplify the essence of city living.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/clayton-residency/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird4",
    //     },
    // },
    // {
    //     id: "al_seef_2_tower",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.07963076, lng: 55.15160723 },
    //     polygonCoords: [],
    //     icon: AlSeef2TowerIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Al Seef 2 Tower',
    //         // previews: [],
    //         // desc: 'Located in JLT Cluster U, Al Seef 2 tower is part of a three-tower complex which comprises a three-level basement parking facility in addition to extensive retail facilities and a full-floor ultra modern health club.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/al-seef-2-tower/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird2",
    //     },
    // },
    // {
    //     id: "sapphire_residence",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.11436563, lng: 55.38998453 },
    //     polygonCoords: [],
    //     icon: SapphireResidenceIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Sapphire Residence',
    //         // previews: [],
    //         // desc: 'With finishes of the finest quality, every home at Sapphire Residence exemplifies our commitment to crafting your space with care and finesse.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/sapphire-residence/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird3",
    //     },
    // },
    // {
    //     id: "mayfair_tower",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.18179354, lng: 55.27814602 },
    //     polygonCoords: [],
    //     icon: MayfairTowerIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Mayfair Tower',
    //         // previews: [],
    //         // desc: 'Every major city on earth has a nerve center – a pulsing, thriving district that anchors the community. These cities centres set the character and tempo of the city, acting as a catalyst for growth, attracting new business and driving the economy',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/mayfair-tower/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird4",
    //     },
    // },
    // {
    //     id: "mar_casa",
    //     checkIsInGroup: true,
    //     groupName: ["future_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.2705156, lng: 55.26945654 },
    //     polygonCoords: [],
    //     icon: MarCasaIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Mar Casa',
    //         // previews: [],
    //         // desc: 'Mar Casa is not just a residence but a gateway to crafting a life that is truly yours. Discover the luxury of emotional development that sets new benchmarks and empowers residents to thrive on their terms.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/mar-casa/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird4",
    //     },
    // },
    // {
    //     id: "midtown",
    //     checkIsInGroup: true,
    //     groupName: ["future_developments", "residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.02865942, lng: 55.18009174 },
    //     polygonCoords: [],
    //     icon: MidtownIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Midtown',
    //         // previews: [],
    //         // desc: 'The Midtown life is a vibrant and thriving community you call home. As a resident of Jannat, you’ll not have a space that’s both personal and secure, you’ll also have a whole lot to discover.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/jannatmidtown/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird1",
    //     },
    // },
    // {
    //     id: "regalia",
    //     checkIsInGroup: true,
    //     groupName: ["future_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 25.18490873, lng: 55.29276712 },
    //     polygonCoords: [],
    //     icon: RegaliaIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Regalia',
    //         // previews: [],
    //         // desc: 'Regalia’s architecture gracefully honours time and inextricably whispers class. The facade’s textural intrigue and contemporary aesthetic sense make it a stunning landmark amongst its neighbours.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.deyaar.ae/en/properties/regalia/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird4",
    //     },
    // },
    // {
    //     id: "millenium_atria",
    //     checkIsInGroup: true,
    //     groupName: ["asset_management"],
    //     zoomLevel: null,
    //     coords: { lat: 25.17971821, lng: 55.26378552 },
    //     polygonCoords: [],
    //     icon: MillenniumAtriaIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Millennium Atria',
    //         // previews: [],
    //         // desc: 'Millennium Atria Business bay is located at the heart of the Business Bay district with very close proximity to the Burj Khalifa - the tallest tower in the world, and The Dubai Mall – the largest mall in the world and the Dubai Downtown area, with a convenient access to and from Sheikh Zayed Road and Al Khail Road. Also, Its very close to Business Bay Metro Station only 10 mins by car.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.millenniumhotels.com/en/dubai/millennium-atria-business-bay/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird4",
    //     },
    // },
    // {
    //     id: "millenium_al_barsha",
    //     checkIsInGroup: true,
    //     groupName: ["asset_management"],
    //     zoomLevel: null,
    //     coords: { lat: 25.11480392, lng: 55.19654048 },
    //     polygonCoords: [],
    //     icon: MillenniumAlBarshaIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         // type: 'card',
    //         // title: 'Millennium Al Barsha',
    //         // previews: [],
    //         // desc: 'Conveniently situated in the bustling Al Barsha area, just a short 3 to 5-minute walk from the renowned Mall of the Emirates, Millennium Al Barsha offers a prime location for both business and leisure travelers. With spacious one and two-bedroom options equipped with full kitchens, our 4-star hotel and hotel apartments cater to all your accommodation needs, whether for long or short stays in Dubai.',
    //         // video: null,
    //         // buttons: [
    //         //     {
    //         //         type: "single",
    //         //         data: [
    //         //             {
    //         //                 text: "WEB SITE",
    //         //                 data: null,
    //         //                 link: 'https://www.millenniumhotels.com/en/dubai/millennium-al-barsha/'
    //         //             },
    //         //         ]
    //         //     },
    //         // ]
    //         type: "bird_link",
    //         bird_id: "bird1",
    //     },
    // },
    // {
    //     id: "millenium_mont_rose",
    //     checkIsInGroup: true,
    //     groupName: ["asset_management"],
    //     zoomLevel: null,
    //     coords: { lat: 25.06973031, lng: 55.24494077 },
    //     polygonCoords: [],
    //     icon: MillenniumMontRoseIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         type: "card",
    //         title: "Millennium Mont Rose",
    //         previews: [],
    //         desc: "Conveniently located in the heart of Al Barsha, Dubai Science Park, our hotel Millennium Mont Rose Executive Apartments offers a vibrant and growing environment for the science sector where businesses and residents can live and thrive in this innovation savvy neighborhood. Millennium Executive Apartments Montrose is 15 to 20 minutes away from the World Trade Centre.",
    //         video: null,
    //         buttons: [
    //             {
    //                 type: "single",
    //                 data: [
    //                     {
    //                         text: "WEB SITE",
    //                         data: null,
    //                         link: "https://www.millenniumhotels.com/en/dubai/millennium-executive-apartments-mont-rose/",
    //                     },
    //                 ],
    //             },
    //         ],
    //     },
    // },
    // {
    //     id: "rosalia_residences",
    //     checkIsInGroup: true,
    //     groupName: ["asset_management"],
    //     zoomLevel: null,
    //     coords: { lat: 25.03435378, lng: 55.14521669 },
    //     polygonCoords: [],
    //     icon: RosaliaResidencesIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         type: "card",
    //         title: "Rosalia Residences",
    //         previews: [],
    //         desc: "Rosalia Residences offers a variety of spacious residential units suitable for families, consisting of one, two and three bedrooms nestled within the serene embrace of nature. Centrally located opposite to the Discovery Gardens 2 Metro Station, Rosalia grants seamless access to vibrant cityscapes.",
    //         video: null,
    //         buttons: [
    //             {
    //                 type: "single",
    //                 data: [
    //                     {
    //                         text: "WEB SITE",
    //                         data: null,
    //                         link: "https://www.deyaar.ae/en/properties/rosalia-residences/",
    //                     },
    //                 ],
    //             },
    //         ],
    //     },
    // },
    // {
    //     id: "eleve_by_deyaar",
    //     checkIsInGroup: true,
    //     groupName: ["residential_developments"],
    //     zoomLevel: null,
    //     coords: { lat: 24.97923341, lng: 55.0932778 },
    //     polygonCoords: null,
    //     icon: EleveByDeyaarIcon,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: false,
    //     },
    //     content: {
    //         type: "card",
    //         title: "Rosalia Residences",
    //         previews: [],
    //         desc: "ELEVE, a modern luxury beacon and all-inclusive enclave, soars above New Dubai. Meticulous design, curated podium amenities, and captivating port views grace its striking facade. ",
    //         video: null,
    //         buttons: [
    //             {
    //                 type: "single",
    //                 data: [
    //                     {
    //                         text: "WEB SITE",
    //                         data: null,
    //                         link: "https://www.deyaar.ae/en/properties/eleve-by-deyaar/",
    //                     },
    //                 ],
    //             },
    //         ],
    //     },
    // },
    {
        id: "bird2",
        hidden: true,
        checkIsInGroup: false,
        groupName: [],
        zoomLevel: null,
        coords: { lat: 25.120258561338918, lng: 55.387619010372 },
        polygonCoords: [],
        icon: null,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: true,
        },
        content: {
            type: "bird",
            background: Bird2Background,
            projects: [
                {
                    id: "one_reem_island",
                    type: "card",
                    title: "One Reem Island",
                    desc: "One Reem Island provides an exceptional living experience, located at the centre of Reem Island, Abu Dhabi with a beachfront setting. Nestled into the capital’s skyline and with views of Abu Dhabi’s renowned mangroves, the striking façade of One Reem Island provides beautiful symmetry with touches of coastal tradition whilst the serene design of the spacious lobby welcomes you home.",
                    link: "https://saasproperties.com/en/properties/city/abu-dhabi/property/one-reem-island",
                    coords: [3134, 881],
                    icon: Bird1PIN,
                    polygon: Bird2OneReemIsland,
                    preview: OneReemIslandImg,
                },
                {
                    id: "reem_five",
                    type: "card",
                    title: "Reem Five",
                    desc: "The sleek exterior of Reem Five solidifies its presence in an incredible location on Abu Dhabi's Reem Island, where the glittering urban city skyline is complemented by the surrounding natural beauty of the mangroves and Arabian waves. Beachfront living provides a sense of calm and gentility which carries through to the interiors of the property, where nature's presence in the fixtures and finishes is abundant. With just 59 exclusive residences from studio through to three-bedroom, the homes within Five Reem are spread generously across eight storeys.",
                    link: "https://saasproperties.com/en/properties/city/abu-dhabi/property/reem-five",
                    coords: [1585, 1454],
                    icon: Bird1PIN,
                    polygon: Bird2ReemFive,
                    preview: ReemFiveImg,
                },
                {
                    id: "reem_eight",
                    type: "card",
                    title: "Reem Eight",
                    desc: "Reem Eight's waterfront position and modern facade offers a striking combination for those looking to find a haven of serenity and peace at the end of the working day without extensive travel. Whilst offering excellent connectivity to an abundance of amenities, Reem Eight's 54 homes have been designed to provide sanctuaries of tranquillity to their residents.",
                    link: "https://saasproperties.com/en/properties/city/abu-dhabi/property/reem-eight",
                    coords: [2813, 834],
                    icon: Bird1PIN,
                    polygon: Bird2ReemEight,
                    preview: ReemEightImg,
                },
                {
                    id: "reem_nine",
                    type: "card",
                    title: "Reem Nine",
                    desc: "From a walking distance to Reem Island's central park and canal, Reem Nine offers an incredible array of unexpected amenities for all residents, from state-of-the-art gym equipment to an on-site cinema, there has been no detail overlooked in creating a community which provides a haven from the buzz of the city. With one to three-bedroom homes, each apartment has been designed to convey the sense of space and light, whilst the development offers views of the mangroves and waterfront for tranquillity and comfort.",
                    link: "https://saasproperties.com/en/properties/city/abu-dhabi/property/reem-nine",
                    coords: [3056, 645],
                    icon: Bird1PIN,
                    polygon: Bird2ReemNine,
                    preview: ReemNineImg,
                },
                {
                    id: "reem_eleven",
                    type: "card",
                    title: "Reem Eleven",
                    desc: "Reem Eleven is a stunning luxury residential tower featuring furnished studios-1 bedroom apartments, and 2-3 bedroom apartments at the heart of Reem Island. This exceptional tower offers an unmatched living experience, with resort-style amenities and lavish living spaces. Located close to everything that matters, Reem Eleven is rapidly taking shape with 19 floors already complete and handover anticipated in Q4 2025.",
                    link: "https://saasproperties.com/en/properties/city/abu-dhabi/property/reem-eleven",
                    coords: [1870, 752],
                    icon: Bird1PIN,
                    polygon: Bird2ReemEleven,
                    preview: ReemElevenImg,
                },
                {
                    id: "saas_business_tower",
                    type: "card",
                    title: "SAAS Business Tower",
                    desc: "SAAS Business Tower stands as a beacon of modernity and sustainability in the prestigious Abu Dhabi Global Market (ADGM) on Reem Island, Abu Dhabi. With its bold, contemporary design and Pearl 3 Estidama Certification—equivalent to Gold/Platinum LEED status—this luxurious 29-story tower represents the pinnacle of sustainable commercial development.",
                    // link: "https://saasproperties.com/en/properties/city/abu-dhabi",
                    coords: [2196, 759],
                    icon: Bird1PIN,
                    polygon: Bird2SaasBusinessTower,
                    preview: SAASBusinessTowerImg,
                },
            ],
        },
    },
    // {
    //     id: "bird2",
    //     checkIsInGroup: false,
    //     groupName: [],
    //     zoomLevel: null,
    //     coords: { lat: 25.084571460218655, lng: 55.14590231685604 },
    //     polygonCoords: [],
    //     icon: Bird2Mark,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         type: "bird",
    //         background: Bird2Background,
    //         projects: [
    //             {
    //                 id: "al_seef_tower",
    //                 type: "card",
    //                 title: "Al Seef Tower",
    //                 desc: "Located in JLT Cluster U, Al Seef 2 tower is part of a three-tower complex which comprises a three-level basement parking facility in addition to extensive retail facilities and a full-floor ultra modern health club.",
    //                 link: "https://www.deyaar.ae/en/properties/al-seef-2-tower/",
    //                 coords: [2941.5, 945.05],
    //                 icon: Bird2AlSeefTower,
    //                 polygon: Bird2AlSeefTowerPolygon,
    //             },
    //             {
    //                 id: "al_seef_2_tower",
    //                 type: "card",
    //                 title: "Al Seef 2 Tower",
    //                 desc: "Located in JLT Cluster U, Al Seef 2 tower is part of a three-tower complex which comprises a three-level basement parking facility in addition to extensive retail facilities and a full-floor ultra modern health club.",
    //                 link: "https://www.deyaar.ae/en/properties/al-seef-2-tower/",
    //                 coords: [1265.5, 959],
    //                 icon: Bird2AlSeefTower2,
    //                 polygon: Bird2AlSeefTower2Polygon,
    //             },
    //         ],
    //     },
    // },
    // {
    //     id: "bird3",
    //     checkIsInGroup: false,
    //     groupName: [],
    //     zoomLevel: null,
    //     coords: { lat: 25.120258561338918, lng: 55.387619010372 },
    //     polygonCoords: [],
    //     icon: Bird3Mark,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         type: "bird",
    //         background: Bird3Background,
    //         projects: [
    //             {
    //                 id: "tria_deyaar",
    //                 type: "card",
    //                 title: "Tria - Deyaar",
    //                 desc: "By serving as a testament to the Dubai 2040 Vision, Tria promises an unmatched lifestyle in the beautifully crafted sanctuary. From the attractions in the neighbourhood to the handsomely appointed amenities and from artfully designed, well-tech homes to mesmerising views, all foster a heightened sense and quality of life.",
    //                 link: "https://www.deyaar.ae/en/properties/tria/",
    //                 coords: [1853.5, 806.5],
    //                 icon: Bird3TriaDeyaar,
    //                 polygon: Bird3TriaDeyaarPolygon,
    //             },
    //             {
    //                 id: "coral_residence",
    //                 type: "card",
    //                 title: "Coral Residence",
    //                 desc: "",
    //                 link: "",
    //                 coords: [701, 1045],
    //                 lineLength: 180,
    //                 anchor: -50,
    //                 icon: Bird3CoralResidence,
    //                 polygon: Bird3CoralResidencePolygon,
    //             },
    //             {
    //                 id: "jade_residence",
    //                 type: "card",
    //                 title: "Jade Residence",
    //                 desc: "",
    //                 link: "",
    //                 coords: [812, 1077],
    //                 lineLength: 70,
    //                 anchor: 50,
    //                 icon: Bird3JadeResidence,
    //                 polygon: Bird3JadeResidencePolygon,
    //             },
    //             {
    //                 id: "ruby_residence",
    //                 type: "card",
    //                 title: "Ruby Residence",
    //                 desc: "",
    //                 link: "",
    //                 coords: [1346, 1249.5],
    //                 lineLength: 50,
    //                 icon: Bird3RubyResidence,
    //                 polygon: Bird3RubyResidencePolygon,
    //             },
    //             {
    //                 id: "sapphire_residence",
    //                 type: "card",
    //                 title: "Sapphire Residence",
    //                 desc: "With finishes of the finest quality, every home at Sapphire Residence exemplifies our commitment to crafting your space with care and finesse.",
    //                 link: "https://www.deyaar.ae/en/properties/sapphire-residence/",
    //                 coords: [1278, 1241],
    //                 lineLength: 150,
    //                 icon: Bird3SapphireResidence,
    //                 polygon: Bird3SapphireResidencePolygon,
    //             },
    //         ],
    //     },
    // },
    // {
    //     id: "bird4",
    //     checkIsInGroup: false,
    //     groupName: [],
    //     zoomLevel: null,
    //     coords: { lat: 25.185272685809725, lng: 55.27074448374538 },
    //     polygonCoords: [],
    //     icon: Bird4Mark,
    //     activeIcon: null,
    //     clickable: {
    //         marker: true,
    //         polygon: true,
    //     },
    //     content: {
    //         type: "bird",
    //         background: Bird4Background,
    //         projects: [
    //             {
    //                 id: "al_dana_tower",
    //                 type: "link",
    //                 title: "Al Dana Tower",
    //                 desc: "",
    //                 link: "https://www.deyaar.ae/en/properties/al-dana-towers/",
    //                 coords: [3414, 539],
    //                 icon: Bird4AlDanaTower,
    //                 polygon: Bird4AlDanaTowerPolygon,
    //             },
    //             {
    //                 id: "the_burlington",
    //                 type: "card",
    //                 title: "The Burlington",
    //                 desc: "Located in the most prestigious area of Business Bay, The Burlington will showcase some of the most esteemed names in the business world.",
    //                 link: "https://www.deyaar.ae/en/properties/burlington/",
    //                 coords: [908, 1164],
    //                 icon: Bird4Burlington,
    //                 polygon: Bird4BurlingtonPolygon,
    //             },
    //             {
    //                 id: "clayton_residency",
    //                 type: "card",
    //                 title: "Clayton Residency",
    //                 desc: "An ultra-contemporary residential project from DEYAAR, Clayton Residency will exemplify the essence of city living.",
    //                 link: "https://www.deyaar.ae/en/properties/clayton-residency/",
    //                 coords: [2573, 1340],
    //                 lineLength: 40,
    //                 icon: Bird4Clayton,
    //                 polygon: Bird4ClaytonPolygon,
    //             },
    //             {
    //                 id: "fairview_residency",
    //                 type: "card",
    //                 title: "Fairview Residency",
    //                 desc: "Completed in 2014, this 18-floor residential tower offers its residents well-designed and comfortable apartments overlooking the Business Bay lake.",
    //                 link: "https://www.deyaar.ae/en/properties/fairview-residency/",
    //                 coords: [2268, 1397],
    //                 lineLength: 210,
    //                 icon: Bird4FairviewResidency,
    //                 polygon: Bird4FairviewResidencyPolygon,
    //             },
    //             {
    //                 id: "fifty_one_business_bay",
    //                 type: "card",
    //                 title: "Fifty One & Business Bay",
    //                 desc: "A state-of-the-art commercial tower, 51& Business Bay is a perfect harmony of elegance, functionality and convenience.",
    //                 link: "https://www.deyaar.ae/en/properties/fifty-one/",
    //                 coords: [2556, 1110],
    //                 icon: Bird4FiftyOne,
    //                 polygon: Bird4FiftyOnePolygon,
    //             },
    //             {
    //                 id: "hamilton_residency",
    //                 type: "card",
    //                 title: "Hamilton Residency",
    //                 desc: "With life getting hectic day after day, you probably find that work makes unreasonable demands on your time, leaving you feeling stretched and stressed. Having a home close to your office helps you strike the right balance.",
    //                 link: "https://www.deyaar.ae/en/properties/hamilton-residency/",
    //                 coords: [2804, 1250],
    //                 icon: Bird4Hamilton,
    //                 polygon: Bird4HamiltonPolygon,
    //             },
    //             {
    //                 id: "mar_casa",
    //                 type: "card",
    //                 title: "Mar Casa",
    //                 desc: "Mar Casa is not just a residence but a gateway to crafting a life that is truly yours. Discover the luxury of emotional development that sets new benchmarks and empowers residents to thrive on their terms.",
    //                 link: "https://www.deyaar.ae/en/properties/mar-casa/",
    //                 coords: [1856, 605],
    //                 icon: Bird4MarCasa,
    //                 polygon: Bird4MarCasaPolygon,
    //             },
    //             {
    //                 id: "mayfair_residency",
    //                 type: "card",
    //                 title: "Mayfair Residency",
    //                 desc: "Offering a choice of 1 and 2 bedroom apartments, Mayfair Residency is designed to impress with its stylish finishes and scenic views of the Business Bay lake.",
    //                 link: "https://www.deyaar.ae/en/properties/mayfair-residency/",
    //                 coords: [2019, 1393],
    //                 lineLength: 10,
    //                 anchor: -250,
    //                 icon: Bird4MayfairResidence,
    //                 polygon: Bird4MayfairResidencePolygon,
    //             },
    //             {
    //                 id: "mayfair_tower",
    //                 type: "card",
    //                 title: "Mayfair Tower",
    //                 desc: "Every major city on earth has a nerve center – a pulsing, thriving district that anchors the community. These cities centres set the character and tempo of the city, acting as a catalyst for growth, attracting new business and driving the economy",
    //                 link: "https://www.deyaar.ae/en/properties/mayfair-tower/",
    //                 coords: [2115, 1395],
    //                 lineLength: 80,
    //                 anchor: 80,
    //                 icon: Bird4MayfairTower,
    //                 polygon: Bird4MayfairTowerPolygon,
    //             },
    //             {
    //                 id: "oxford_tower",
    //                 type: "card",
    //                 title: "Oxford Tower",
    //                 desc: "Oxford Tower is the exclusive address that compliments your business and positions it in the heart of a vibrant business district. Flaunt the stature that your business exudes and join the leading corporate names of the world.",
    //                 link: "https://www.deyaar.ae/en/properties/oxford-tower/",
    //                 coords: [1468, 1642],
    //                 icon: Bird4Oxford,
    //                 polygon: Bird4OxfordPolygon,
    //             },
    //             {
    //                 id: "regalia",
    //                 type: "card",
    //                 title: "Regalia",
    //                 desc: "Regalia’s architecture gracefully honours time and inextricably whispers class. The facade’s textural intrigue and contemporary aesthetic sense make it a stunning landmark amongst its neighbours.",
    //                 link: "https://www.deyaar.ae/en/properties/regalia/",
    //                 coords: [3409, 1058],
    //                 icon: Bird4RegaliaByDeyaar,
    //                 polygon: Bird4RegaliaByDeyaarPolygon,
    //             },
    //             {
    //                 id: "the_atria",
    //                 type: "card",
    //                 title: "The Atria",
    //                 desc: "The apartments at The Atria are designed in the yoo Studio Culture Style. Eclectic yet refined, the Culture palette encapsulates a passion for appropriating the most beautiful and exquisitely produced objects and ideas from the past, and placing them alongside the most amazing designs of today.",
    //                 link: "https://www.deyaar.ae/en/properties/the-atria/",
    //                 coords: [504, 1413],
    //                 lineLength: 15,
    //                 anchor: 145,
    //                 icon: Bird4TheAtria,
    //                 polygon: Bird4TheAtriaPolygon,
    //             },
    //             {
    //                 id: "millenium_atria",
    //                 type: "card",
    //                 title: "Millennium Atria",
    //                 desc: "Millennium Atria Business bay is located at the heart of the Business Bay district with very close proximity to the Burj Khalifa - the tallest tower in the world, and The Dubai Mall – the largest mall in the world and the Dubai Downtown area, with a convenient access to and from Sheikh Zayed Road and Al Khail Road. Also, Its very close to Business Bay Metro Station only 10 mins by car.",
    //                 link: "https://www.millenniumhotels.com/en/dubai/millennium-atria-business-bay/",
    //                 coords: [493.5, 1437],
    //                 lineLength: 70,
    //                 anchor: -185,
    //                 icon: Bird4MillenniumAtria,
    //                 polygon: Bird4MillenniumAtriaPolygon,
    //             },
    //             {
    //                 id: "the_citadel_tower",
    //                 type: "card",
    //                 title: "The Citadel Tower",
    //                 desc: "Located in an enviable position in Business Bay, this corporate business tower boasts 41 floors of beautifully designed office spaces overlooking the bay.",
    //                 link: "https://www.deyaar.ae/en/properties/the-citadel/",
    //                 coords: [573, 1178.5],
    //                 anchor: -75,
    //                 icon: Bird4TheCitadel,
    //                 polygon: Bird4TheCitadelPolygon,
    //             },
    //             {
    //                 id: "the_metropolis",
    //                 type: "card",
    //                 title: "The Metropolis",
    //                 desc: "The Metropolis is on par with leading international names in the commercial world, offering position and power of a perfect location in the world’s most powerful business community – the Business Bay of Dubai.",
    //                 link: "https://www.deyaar.ae/en/properties/the-metropolis/",
    //                 coords: [1967, 1229],
    //                 lineLength: 160,
    //                 icon: Bird4TheMetropolis,
    //                 polygon: Bird4TheMetropolisPolygon,
    //             },
    //         ],
    //     },
    // },
    {
        id: "abu_dhabi_international_airport",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.451479013423686, lng: 54.642233683370904 },
        polygonCoords: null,
        icon: AbuDhabiInternationalAirport,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "khalifa_port",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.810125565967105, lng: 54.64948576683413 },
        polygonCoords: null,
        icon: KhalifaPort,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "mina_zayed_port",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.52285254427876, lng: 54.387354002782466 },
        polygonCoords: null,
        icon: MinaZayedPort,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "sheikh_zayed_grand_mosque",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.416722425858612, lng: 54.47543832186147 },
        polygonCoords: null,
        icon: SheikhZayedGrandMosque,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "louvre_abu_dhabi",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.533939383078845, lng: 54.398222626342644 },
        polygonCoords: null,
        icon: LouvreAbuDhabi,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "ferrari_world",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.483972289689742, lng: 54.60723086497616 },
        polygonCoords: null,
        icon: FerrariWorld,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "yas_waterworld",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.487851308831292, lng: 54.59974355517637 },
        polygonCoords: null,
        icon: YasWaterworld,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "emirates_palace",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.462839664594963, lng: 54.317085886987215 },
        polygonCoords: null,
        icon: EmiratesPalace,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "qasr_al_hosn",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.482481083040945, lng: 54.35484101284687 },
        polygonCoords: null,
        icon: QasrAlHosn,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "al_ain_oasis",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.222440018766605, lng: 55.76354712457006 },
        polygonCoords: null,
        icon: AlAinOasis,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "heritage_village",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.477246276837214, lng: 54.33084086462363 },
        polygonCoords: null,
        icon: HeritageVillage,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "headquarters",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.462126530511878, lng: 54.32424468216378 },
        polygonCoords: null,
        icon: Headquarters,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "abu_dhabi_global_market",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.501326932758513, lng: 54.388756011000304 },
        polygonCoords: null,
        icon: AbuDhabiGlobalMarket,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "masdar_city",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.42649705573599, lng: 54.61530479002429 },
        polygonCoords: null,
        icon: MasdarCity,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "abu_dhabi_ports_free_zone",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.810522035238932, lng: 54.64950560928206 },
        polygonCoords: null,
        icon: AbuDhabiPortsFreeZone,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "al_ain_industrial_city",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.18378654664092, lng: 55.76162862448407 },
        polygonCoords: null,
        icon: AlAinIndustrialCity,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "mussafah_industrial_area",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.36432965748984, lng: 54.510422723143265 },
        polygonCoords: null,
        icon: MussafahIndustrialArea,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "al_maryah_island_business_district",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.498587311558676, lng: 54.38906939437752 },
        polygonCoords: null,
        icon: AlMaryahIslandBusinessDistrict,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "industrial_city_of_abu_dhabi",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.33278114564557, lng: 54.49431240944538 },
        polygonCoords: null,
        icon: IndustrialCityOfAbuDhabi,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "abu_dhabi_airport_free_zone",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.429401065969966, lng: 54.64208001746042 },
        polygonCoords: null,
        icon: AbuDhabiAirportFreeZone,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "two_four_54_media_zone",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.469754191034696, lng: 54.62187825175662 },
        polygonCoords: null,
        icon: TwoFour54MediaZone,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "khalifa_industrial_zone",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.73068399747252, lng: 54.72598603811945 },
        polygonCoords: null,
        icon: KhalifaIndustrialZone,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "abrahamic_family_house",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.531074888648618, lng: 54.406737002483965 },
        polygonCoords: null,
        icon: AbrahamicFamilyHouse,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "al_bahr_towers",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.45646524972627, lng: 54.40037985204581 },
        polygonCoords: null,
        icon: AlBahrTowers,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "aldar_headquarters",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.441371127977373, lng: 54.5760599987868 },
        polygonCoords: null,
        icon: AldarHeadquarters,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "al_jahili_fort",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.21627459525813, lng: 55.75307064721457 },
        polygonCoords: null,
        icon: AlJahiliFort,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "sheikh_zayed_bridge",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.42425378362432, lng: 54.48657294906858 },
        polygonCoords: null,
        icon: SheikhZayedBridge,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "burj_mohammed_bin_rashid",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.487376182071486, lng: 54.3574335803175 },
        polygonCoords: null,
        icon: BurjMohammedBinRashid,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "capital_gate_building",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.41865672271525, lng: 54.4350312374212 },
        polygonCoords: null,
        icon: CapitalGateBuilding,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "qasr_al_watan",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.462186272655796, lng: 54.306495983062014 },
        polygonCoords: null,
        icon: QasrAlWatan,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "emirates_palace_mandarin_oriental",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.461579881877768, lng: 54.31874885645812 },
        polygonCoords: null,
        icon: EmiratesPalaceMandarinOriental,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "w_abu_dhabi",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.467905240990227, lng: 54.60557199509346 },
        polygonCoords: null,
        icon: WAbuDhabi,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "etihad_towers",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.458819073067424, lng: 54.32195304233373 },
        polygonCoords: null,
        icon: EtihadTowers,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "wahat_al_karama",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.413661568743766, lng: 54.47909911838578 },
        polygonCoords: null,
        icon: WahatAlKarama,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },

    {
        id: "reem_island_mangrove_forest",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.503675791663884, lng: 54.40438736810647 },
        polygonCoords: null,
        icon: ReemIslandMangroveForest,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "reem_central_park_and_beach",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.50408581766048, lng: 54.40614689709505 },
        polygonCoords: null,
        icon: ReemCentralParkAndBeach,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "al_fay_park",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.491803664945646, lng: 54.40577473742369 },
        polygonCoords: null,
        icon: AlFayPark,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "yas_waterworld",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.48779272620805, lng: 54.600119064411736 },
        polygonCoords: null,
        icon: YasWaterworld,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "warner_brothers_world",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.491005386384224, lng: 54.598914030599936 },
        polygonCoords: null,
        icon: WarnerBrothersWorld,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "yas_beach",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.461566036303886, lng: 54.592529291399195 },
        polygonCoords: null,
        icon: YasBeach,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "yas_links",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.478486168232866, lng: 54.600622854611494 },
        polygonCoords: null,
        icon: YasLinks,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "yas_marina_circuit",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.48043868116102, lng: 54.604431528046256 },
        polygonCoords: null,
        icon: YasMarinaCircuit,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "yas_gateway_park_north",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.49149853344483, lng: 54.6292405070479 },
        polygonCoords: null,
        icon: YasGatewayParkNorth,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "seaworld",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.487922770201624, lng: 54.618262370739686 },
        polygonCoords: null,
        icon: Seaworld,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "clymb",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.486040536893082, lng: 54.607636639270616 },
        polygonCoords: null,
        icon: Clymb,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
    {
        id: "yas_bay_waterfront",
        checkIsInGroup: true,
        groupName: ["landmarks"],
        zoomLevel: null,
        coords: { lat: 24.458148788955707, lng: 54.59959225674029 },
        polygonCoords: null,
        icon: YasBayWaterfront,
        activeIcon: null,
        clickable: {
            marker: true,
            polygon: false,
        },
        content: null,
    },
];

export const polylines = [
    {
        id: "bus_station_1",
        path: bus_road_1,
        stops: bus_road_1_stops,
        icon: MarkBus1,
        color: "#EC5650",
    },
    {
        id: "bus_station_1_2",
        path: bus_road_1_2,
        stops: [],
        icon: MarkBus1,
        color: "#EC5650",
    },
    {
        id: "bus_station_2",
        path: bus_road_2,
        stops: bus_road_2_stops,
        icon: MarkBus2,
        color: "#49CD57",
    },
    {
        id: "bus_station_3",
        path: bus_road_3,
        stops: bus_road_3_stops,
        icon: MarkBus3,
        color: "#F26E24",
    },
];
